/** Мають збігатися з ONBOARDING_REWARD_* у бекенді (claim-onboarding-reward). */
/** Mirrors app/user/onboarding.py (also paid for a comeback replay; doubled for allowing bot messages). */
export const ONBOARDING_REWARD_PEARLS = 250_000;
export const ONBOARDING_REWARD_EXP = 250_000;
export const ONBOARDING_REWARD_PEARL_ICON_SRC = "/ui/daily-rewards/daily-rewards-pearls-gift.png";
export const ONBOARDING_REWARD_EXP_ICON_SRC = "/ui/daily-rewards/daily-rewards-exp-gift.png";

export function OnboardingRewardAmountRow({
  iconSrc,
  amount,
  numberLocale,
}: {
  iconSrc: string;
  amount: number;
  numberLocale: string;
}) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        justifyContent: "center",
      }}
    >
      <span
        style={{
          fontFamily: "Lato, sans-serif",
          fontSize: 17,
          fontWeight: 800,
          color: "#FFD700",
        }}
      >
        +{amount.toLocaleString(numberLocale)}
      </span>
      <img
        src={iconSrc}
        alt=""
        width={28}
        height={28}
        loading="lazy"
        style={{ objectFit: "contain", flexShrink: 0 }}
      />
    </div>
  );
}
